/* 触发固定头部，浮动按钮 */
<template>
  <div id="affix-top" class="affix-out-main">
    <Affix
      class="affix-top"
      v-if="tabNav"
      :offset-top="offset"
      @on-change="offsetChangeHandle"
    >
      <div class="affix-top-btn" :class="['animated', 'fast', 'fadeIn']">
        <div class="affix-offset-main">
          <slot></slot>
        </div>
      </div>
    </Affix>
  </div>
</template>
<script>
import { throttle, debounce} from '../../utils/assist.js'
export default {
  name: "ZAffixTopBtn",
  data() {
    return {
      tabNav: false
    };
  },
  props: {
    scrollOffset: {
      type: [String, Number],
      default: 200
    },
    offset: {
      type: [String, Number],
      default: 0
    }
  },
  methods: {
    offsetChangeHandle() {
      //   console.log("触发显示了affix-top-btn");
    },
    handleScroll() {
      let scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      if (scrollTop > this.scrollOffset) {
        this.tabNav = true;
      } else if (scrollTop < this.scrollOffset) {
        this.tabNav = false;
      }
    },
    // 重置头部宽度
    setTopWidth() {
      /* 当前 ivu-affix 的宽度*/
      let affix_d = document.getElementById("affix-top"),
        affix_w =
          document.documentElement.scrollWidth || document.body.scrollWidth;
      affix_d ? (affix_d.style.width = affix_w + "px") : "";
    }
  },
  watch: {
    tabNav: function() {
      if (this.tabNav) {
        this.setTopWidth();
      }
    }
  },
  mounted() {
    window.addEventListener("scroll", throttle(this.handleScroll, 300));
    window.addEventListener('resize', throttle(this.setTopWidth, 1000));
  }
};
</script>
